<a [attr.href]="authUrl$ | async" title="Use Google authorization"></a>
